import React from "react";
import { Tab, Tabs } from "react-bootstrap";
import Modal from "react-bootstrap/Modal";
import Pagination from "react-js-pagination";
import { formatNumber2 } from "utils/currencyFormat";
import { formatNumber } from "utils/currencyFormat";
import { getDate, currentDate, formatDayMonth } from "utils/formatDate";
import { convertToNumber } from "utils/numberExtension";
import ChiTietChoVaySub from "../ChiTietChoVaySub";
import { LanDongLaiSub } from "./LanDongLaiSub";
import PhiKhacApi from "service/phiKhacApi";
import { pushNotification } from "utils/notifications";
import InLanDongLai from "containers/Common/QuanLyChoVay/inLanDongLai";
import InDanhSachPhiKhac from "containers/Common/QuanLyChoVay/inDanhSachPhiKhac";
import DateTimePicker from "components/GenericComponent/DateTimePicker";
import { convertDate } from "utils/formatDate";
import { PopoversBootrap } from "components/GenericComponent/PopoversBootrap";
import QuanLyChoVayApi from "service/quanLyChoVayApi";
import ReactDropdown from "react-dropdown";
import { BtnPhiHangKy } from "../PhiHangKy/BtnPhiHangKy";
import userApi from "../../../service/userApi";
import TraGopApi from "service/traGopApi";
import { formatCurrency, formatCurrency2 } from "utils/currencyFormat";
import cauHinh from "utils/cauHinh";
import handleEscapeKey from "utils/handleEscapeKey";
import CauHinhApi from "../../../service/cauHinhApi";
import dsBankApi from "service/TichHopBank/dsBankApi";
import ChoThanhToanApi from "../../../service/TichHopBank/choThanhToanApi";
import TatToanChoDuyetApi from "../../../service/tatToanChoDuyetApi";
import { ModelThietLapHienThi } from "./ModelThietLapHienThi";
import ThietLapHienThiApi from "../../../service/QuanTriHeThong/ThietLapHienThiApi";
import { currentDateV2 } from "utils/formatDate";

class DongLai extends React.Component {
  constructor(props) {
    super(props);
    let isShow = true;
    let displayText = "contents";
    if (matchMedia) {
      var mq = window.matchMedia("(max-width: 768px)");
      isShow = !mq.matches;
      if (mq.matches) displayText = "block";
    }
    this.state = {
      isModalOpen: props.show || false, // Trạng thái popup
      choVay: {},
      dataSearch: {
        choVayId: 0,
        pageIndex: 1,
        pageSize: 10,
      },
      objThanhToan: {
        CustomerName: "",
        NgayThanhToan: new Date(),
        SoTien: 0,
        PhiKhac: 0,
        PhiKho: 0,
        GhiChu: "",
        DoiKy: false,
        PhiPhatTraLai: 0,
        PhiPhatTraCham: 0,
      },
      editItem: {},
      showModal: false,
      isShowFormDongLai: isShow,
      itemShow: {
        item: null,
        isShow: isShow,
        displayText,
      },
      phiPhat: {},
      lstPhiKhac: [],
      totalPhiKhac: 0,
      isEditGhiChu: 0,
      dataGhiChu: {
        Id: 0,
        PaidId: 0,
        GhiChu: "",
        NgayTao: new Date(),
        NguoiTao: "",
      },
      listGhiChu: [],
      isShowGhiChuTraGop: false,
      isCauHinhT86: false,
      isCauHinhT77: false,
      isQRThanhToan: false,
      lstBank: [],
      IdCuaHang: "",
      bankId: "",
      imgUrlQR: "",
      isShowInKhiThanhToan: true,
      isCauHinhKhachHangVSNY: false,
      HasTatToanChoDuyet: 0,
      isShowModalThietLapHienThi: false,
      objThietLapHienThiDanhSach: {},
      soTienThanhToan: 0,
      soNgayTraCham: 0,
      soNgayTinhPhat: 0,
      isWinmoney: false,
    };
    this.toggleModal = this.props.onHide.bind(this);
    // Tạo instance của useEscapeKey và gán vào this.escListener
    this.escListener = handleEscapeKey(this.props.onHide);
  }

  getTimeServer() {
    let { updateObjThanhToan } = this.props;
    let { objThanhToan } = this.state;
    CauHinhApi.getTimeServer().then((response) => {
      if (response.status === 200) {
        let dateTime = new Date(convertDate(response.data.result));
        objThanhToan.NgayThanhToan = currentDateV2(dateTime);
        updateObjThanhToan(objThanhToan);
      }
    });
  }
  componentDidMount() {
    if (this.state.isModalOpen) this.escListener.addListener();
    let { data, updateObjThanhToan, getLaiDenKyChoVay, show, getComboCHDT } =
      this.props;
    let { objThanhToan, soTienThanhToan } = this.state;
    if (show) {
      let { dataSearch } = this.state;
      dataSearch.choVayId = data.ChoVayId;
      // dataSearch.pageIndex = 2;
      objThanhToan.CustomerName = data.CustomerName;
      objThanhToan.SoTien = data.Value;
      objThanhToan.PhiKho = data.PhiKho;
      objThanhToan.NgayThanhToan = currentDate();
      objThanhToan.PhiPhatTraLai = data.PhiPhatTraLai;
      objThanhToan.PhiDongLaiCham = data.PhiDongLaiCham;
      soTienThanhToan = data.Value;
      this.setState({
        choVay: data,
        dataSearch,
        objThanhToan,
        soTienThanhToan,
      });
      getLaiDenKyChoVay({
        choVayId: data.ChoVayId,
        toDate: objThanhToan.NgayThanhToan,
      });
      this.getTimeServer();

      updateObjThanhToan(objThanhToan);
      getComboCHDT();
      this.getThietLapHienThi();
      QuanLyChoVayApi.layTrangLanThanhToan(
        data.ChoVayId,
        dataSearch.pageSize,
      ).then((d) => {
        dataSearch.pageIndex = d.data;
        this.loadLanDongLai(dataSearch);
      });
      TraGopApi.getConfigSys().then((response) => {
        if (response.status === 200) {
          if (response.data.length > 0) {
            const isShowNote = response.data.find(
              (e) =>
                e.keyConfig.toUpperCase() ===
                cauHinh.sKey.IsShowGhiChu.toUpperCase(),
            );
            if (isShowNote != null) {
              if (isShowNote.valueConfig === "1") {
                this.setState({ isShowGhiChuTraGop: true });
              }
            }
          }
        }
      });

      PhiKhacApi.listTheoChoVay1(data.ChoVayId, data.TypePaid).then(
        (response) => {
          let state = this.state;
          state.lstPhiKhac = response.data;
          if (response.data.length > 0) {
            var tongtien = 0;
            response.data.map((item, index) => {
              tongtien += item.ThanhTien;
            });
            state.totalPhiKhac = tongtien;
            this.setState(state);
          }
        },
      );
      CauHinhApi.getConfigSys1().then((response) => {
        if (response.status === 200) {
          if (response.data.length > 0) {
            const isCauHinhT86 = response.data.find(
              (e) =>
                e.keyConfig.toUpperCase() ===
                cauHinh.sKey.IsCauHinhT86.toUpperCase(),
            );
            if (isCauHinhT86 != null) {
              if (isCauHinhT86.valueConfig === "1") {
                this.setState({ isCauHinhT86: true });
              }
            }
            const configCauHinhT77 = response.data.find(
              (e) =>
                e.keyConfig &&
                e.keyConfig.toUpperCase() ===
                  cauHinh.sKey.IsCauHinhT77.toUpperCase(),
            );
            if (configCauHinhT77 != null) {
              if (configCauHinhT77.valueConfig === "1") {
                this.setState({ isCauHinhT77: true });
              }
            }
            const configIsQRThanhToan = response.data.find(
              (e) =>
                e.keyConfig.toUpperCase() ===
                cauHinh.sKey.IsQRThanhToan.toUpperCase(),
            );
            if (configIsQRThanhToan != null) {
              if (configIsQRThanhToan.valueConfig === "1") {
                this.setState({ isQRThanhToan: true });
              }
            }
            const configNangCapKhachHangVSNY = response.data.find(
              (e) =>
                e.keyConfig.toUpperCase() ===
                cauHinh.sKey.IsNangCapKHVSNY.toUpperCase(),
            );
            if (configNangCapKhachHangVSNY != null) {
              if (configNangCapKhachHangVSNY.valueConfig === "1") {
                this.setState({ isShowInKhiThanhToan: false });
                this.setState({ isCauHinhKhachHangVSNY: true });
              }
            }
            // Nhà Winmoney mới có trường "Tiền phạt trả chậm", nhà khác không
            // gọi api phí phạt để khỏi tốn thêm một lượt truy vấn.
            const configWinmoney = response.data.find(
              (e) =>
                e.keyConfig &&
                e.keyConfig.toUpperCase() ===
                  cauHinh.sKey.IsWinmoney.toUpperCase(),
            );
            if (configWinmoney != null && configWinmoney.valueConfig === "1") {
              this.setState({ isWinmoney: true });
              this.loadPhiPhatTraCham(
                data.ChoVayId,
                objThanhToan.NgayThanhToan,
              );
            }
          }
        }
      });
      dsBankApi
        .list({
          sSearch: "",
          sMaNganHang: "",
          iPageSize: -1,
          iPageIndex: -1,
          isKhoa: 0,
          isDangKyNhanPushBDSD: null,
        })
        .then((res) => {
          if (res.status === 200) {
            this.setState({ lstBank: res.data.List });
          }
        });
      userApi.getCurrentUser().then((res) => {
        this.setState({ IdCuaHang: res.data.CompanyID });
      });
      this.kiemTraHopDongChoVayTatToanChoDuyet();
      // this.getTime();
    }
  }

  componentWillUnmount() {
    // Gỡ listener khi component unmount
    this.escListener.removeListener();
  }
  getThietLapHienThi() {
    ThietLapHienThiApi.thietLapDongLai().then((response) => {
      this.setState({ objThietLapHienThiDanhSach: response.data });
    });
  }
  toggleModal() {
    // Cập nhật trạng thái popup và thêm/xóa listener khi cần
    this.setState(
      (prevState) => ({ isModalOpen: !prevState.isModalOpen }),
      () => {
        if (this.state.isModalOpen) {
          this.escListener.addListener();
        } else {
          this.escListener.removeListener();
        }
      },
    );
  }
  kiemTraHopDongChoVayTatToanChoDuyet() {
    let { data } = this.props;
    let { HasTatToanChoDuyet } = this.state;
    TatToanChoDuyetApi.kiemTraHopDongChoVayTatToanChoDuyet(data.ChoVayId).then(
      (response) => {
        if (
          response.data != null &&
          response.data != undefined &&
          response.data.TatToanChoDuyet
        ) {
          HasTatToanChoDuyet = response.data.TatToanChoDuyet;
          this.setState({ HasTatToanChoDuyet });
        }
      },
    );
  }
  onHide = () => {
    this.setState({ isModalOpen: false });
    this.props.onHide();
  };

  showRow = (item) => () => {
    let { itemShow } = this.state;
    let isShow = true;
    if (window.innerWidth < 900) {
      isShow = !itemShow.isShow;
      itemShow.item = item;
      itemShow.isShow = isShow;
      this.setState({ itemShow });
    }
  };
  loadLanDongLai(dataSearch) {
    let { getLanDongLaiChoVay } = this.props;
    getLanDongLaiChoVay(dataSearch);
  }
  onChangeData = (field, event) => {
    let state = this.state;
    state[field] = event.target.value;
    this.setState(state);
  };
  handlePageChange = (pageNumber) => {
    let { dataSearch } = this.state;
    dataSearch.pageIndex = pageNumber;
    this.setState({ dataSearch });
    this.loadLanDongLai(dataSearch);
  };
  thanhToan = (soTien, thuId) => () => {
    let { dataSearch, isShowInKhiThanhToan } = this.state;
    let { postThanhToanChoVay, deleteThanhToanChoVay, data } = this.props;
    if (!thuId || (soTien && parseFloat(soTien) > 0))
      postThanhToanChoVay(
        {
          choVayId: data.ChoVayId,
          soTien,
          isShowInKhiThanhToan: isShowInKhiThanhToan,
        },
        dataSearch,
      );
    // else deleteThanhToanChoVay({ thuChiId: thuId }, dataSearch);
  };
  deletethanhToan = (soTien, thuId) => () => {
    let { dataSearch, soTienThanhToan } = this.state;
    let { updateObjThanhToan, quanlythuchi } = this.props;
    let { objThanhToan } = quanlythuchi;
    let { postThanhToanChoVay, deleteThanhToanChoVay, data } = this.props;
    deleteThanhToanChoVay({ thuChiId: thuId }, dataSearch);
    console.log("soTien", soTien);
    soTienThanhToan = soTienThanhToan + Number(soTien);
    console.log("soTienThanhToan", soTienThanhToan);
    objThanhToan.SoTien = soTienThanhToan;
    this.setState({ soTienThanhToan });
    updateObjThanhToan(objThanhToan);
  };
  thanToanAll = () => () => {
    let { dataSearch, isShowInKhiThanhToan, soTienThanhToan } = this.state;
    let {
      postThanhToanAllChoVay,
      data,
      quanlythuchi,
      updateObjThanhToan,
      cuahangdoitac,
    } = this.props;
    let { objThanhToan } = quanlythuchi;
    if (!objThanhToan.CustomerName) {
      pushNotification("Nhập tên khách hàng", "warning", "TOP_CENTER", 1000);
      return;
    }

    if (
      Number(objThanhToan.SoTien ?? 0) +
        Number(objThanhToan.PhiKhac ?? 0) +
        Number(objThanhToan.PhiKho ?? 0) <=
      0
    ) {
      pushNotification("Nhập số tiền thu", "warning", "TOP_CENTER", 1000);
      return;
    }

    let { combo } = cuahangdoitac;
    if (!objThanhToan.KenhThanhToan) {
      objThanhToan.KenhThanhToan = combo[0].value;
    }
    postThanhToanAllChoVay(
      {
        ChoVayId: data.ChoVayId,
        TenKhachHang: objThanhToan.CustomerName,
        NgayTra: objThanhToan.NgayThanhToan,
        SoTienDong: objThanhToan.SoTien,
        PhiKho: objThanhToan.PhiKho,
        PhiKhac: objThanhToan.PhiKhac,
        GhiChu: objThanhToan.GhiChu,
        DoiKy: objThanhToan.DoiKy,
        DongThemQuaHan: objThanhToan.soNgayQuanHan > 0,
        SoTienPhaiDong: objThanhToan.SoTienPhaiDong,
        KenhThanhToan: objThanhToan.KenhThanhToan,
        PhiPhatTraLai: objThanhToan.PhiPhatTraLai,
        // Trên form phải để riêng hai ô vì reducer của api lai-den-ngay ghi đè
        // PhiDongLaiCham, nhưng khi gửi thì gộp làm một vì cùng vào một cột ThuChi.
        PhiDongLaiCham:
          Number(objThanhToan.PhiDongLaiCham || 0) +
          Number(objThanhToan.PhiPhatTraCham || 0),
        isShowInKhiThanhToan: isShowInKhiThanhToan,
      },
      dataSearch,
    );
    soTienThanhToan = soTienThanhToan - objThanhToan.SoTien;
    this.setState({ soTienThanhToan });
    objThanhToan.SoTien = soTienThanhToan < 0 ? 0 : soTienThanhToan;

    // objThanhToan.NgayThanhToan = currentDate()
    objThanhToan.PhiPhatTraLai = 0;
    objThanhToan.PhiDongLaiCham = 0;
    objThanhToan.PhiPhatTraCham = 0;
    // Ô phạt đã về 0 thì nhãn số ngày cũng phải mất theo, kẻo hiện "0đ (20 ngày)"
    this.setState({ soNgayTraCham: 0, soNgayTinhPhat: 0 });
    // updateObjThanhToan(objThanhToan);
    CauHinhApi.getTimeServer().then((response) => {
      if (response.status === 200) {
        let dateTime = new Date(convertDate(response.data.result));
        objThanhToan.NgayThanhToan = currentDateV2(dateTime);
        updateObjThanhToan(objThanhToan);
      }
    });
  };
  thanToanCho = () => () => {
    let { dataSearch, soTienThanhToan } = this.state;
    let {
      postThanhToanAllChoVay,
      data,
      quanlythuchi,
      updateObjThanhToan,
      cuahangdoitac,
    } = this.props;
    let { objThanhToan } = quanlythuchi;
    if (!objThanhToan.CustomerName) {
      pushNotification("Nhập tên khách hàng", "warning", "TOP_CENTER", 1000);
      return;
    }
    if (!objThanhToan.SoTien) {
      pushNotification("Nhập số tiền thu 1", "warning", "TOP_CENTER", 1000);
      return;
    }
    let { combo } = cuahangdoitac;
    if (!objThanhToan.KenhThanhToan) {
      objThanhToan.KenhThanhToan = combo[0].value;
    }

    // postThanhToanAllChoVay(
    //   {
    //     ChoVayId: data.ChoVayId,
    //     TenKhachHang: objThanhToan.CustomerName,
    //     NgayTra: objThanhToan.NgayThanhToan,
    //     SoTienDong: objThanhToan.SoTien,
    //     PhiKho: objThanhToan.PhiKho,
    //     PhiKhac: objThanhToan.PhiKhac,
    //     GhiChu: objThanhToan.GhiChu,
    //     DoiKy: objThanhToan.DoiKy,
    //     DongThemQuaHan: objThanhToan.soNgayQuanHan > 0,
    //     SoTienPhaiDong: objThanhToan.SoTienPhaiDong,
    //     KenhThanhToan: objThanhToan.KenhThanhToan,
    //     PhiPhatTraLai: objThanhToan.PhiPhatTraLai,
    //     PhiDongLaiCham: objThanhToan.PhiDongLaiCham,
    //   },
    //   dataSearch
    // );
    objThanhToan.ChoVayId = data.ChoVayId;
    objThanhToan.DongThemQuaHan = objThanhToan.soNgayQuanHan > 0;
    objThanhToan.NgayTra = objThanhToan.NgayThanhToan;
    objThanhToan.SoTienDong = objThanhToan.SoTien;
    ChoThanhToanApi.saveChoThanhToanDongLai(objThanhToan).then((response) => {
      if (response.status === 200) {
        pushNotification(
          "Tạo chờ thanh toán thành công.",
          "success",
          "TOP_RIGHT",
          2000,
        );
      } else {
        pushNotification("Có lỗi xảy ra.", "warning", "TOP_CENTER", 1000);
      }
    });

    soTienThanhToan = soTienThanhToan - objThanhToan.SoTien;
    this.setState({ soTienThanhToan });
    objThanhToan.SoTien = soTienThanhToan < 0 ? 0 : soTienThanhToan;
    // objThanhToan.NgayThanhToan = currentDate();
    // this.getTimeServer();
    objThanhToan.PhiPhatTraLai = 0;
    objThanhToan.PhiDongLaiCham = 0;
    // updateObjThanhToan(objThanhToan);
    CauHinhApi.getTimeServer().then((response) => {
      if (response.status === 200) {
        let dateTime = new Date(convertDate(response.data.result));
        objThanhToan.NgayThanhToan = currentDateV2(dateTime);
        updateObjThanhToan(objThanhToan);
      }
    });
  };
  setEditItem = (item) => () => {
    this.setState({ editItem: item });
  };
  onChangeValuePaidEdit = (field) => (evt) => {
    let { editItem } = this.state;
    if (
      evt.target.value === "" ||
      evt.target.value === "" ||
      evt.target.value == undefined
    ) {
      editItem[field] = "0";
    } else {
      editItem[field] = convertToNumber(evt.target.value);
    }
    this.setState({ editItem });
  };
  onChangePhiPhat = (index) => (evt) => {
    let { phiPhat } = this.state;
    phiPhat[index] = convertToNumber(evt.target.value);
    this.setState({ phiPhat });
  };
  handleKeyDown = (event) => {
    if (event.key === "Enter") {
      let { editItem, dataSearch } = this.state;
      let { suaTienLai } = this.props;
      suaTienLai(
        { paidId: editItem.PaidID, valuePaid: editItem.ValuePaid },
        dataSearch,
      );
    }
  };
  handleKeyDownValueGoc = (event) => {
    if (event.key === "Enter") {
      this.onblurValueGoc()();
    }
  };
  handleKeyDownValueGop = (event) => {
    if (event.key === "Enter") {
      this.onblurValueGop()();
    }
  };

  handleKeyDownPhiPhat = (index) => (event) => {
    if (event.key === "Enter") {
      this.onblurPhiPhat(index)();
    }
  };
  onblurValuePaid = () => () => {
    let { editItem, dataSearch } = this.state;
    let { suaTienLai } = this.props;
    suaTienLai(
      { paidId: editItem.PaidID, valuePaid: editItem.ValuePaid },
      dataSearch,
    );
  };
  onblurValueGoc = () => () => {
    let { editItem, dataSearch } = this.state;
    let { suaTienGoc } = this.props;
    suaTienGoc(
      { paidId: editItem.PaidID, valueGoc: editItem.ValueGoc },
      dataSearch,
    );
  };

  onblurValueGop = () => () => {
    let { editItem, dataSearch } = this.state;
    let { suaTienGop } = this.props;
    suaTienGop(
      { paidId: editItem.PaidID, valueGop: editItem.ValueGop },
      dataSearch,
    );
  };
  onb;

  onblurPhiPhat = (index) => () => {
    let { dataSearch, phiPhat } = this.state;
    let { nhapPhiPhat } = this.props;
    nhapPhiPhat({ paidId: index, phiPhat: phiPhat[index] }, dataSearch);
  };

  setGhiChuShow = (item, index, List) => () => {
    let objGhiChu = this.state.dataGhiChu;
    TraGopApi.ChiTietGhiChu(item.PaidID).then((response) => {
      if (response.status === 200) {
        this.setState({ listGhiChu: response.data });
      }
    });

    List.length > 0 &&
      List.map((dataDongLai, i) => {
        if (i === index) {
          this.setState({ isEditGhiChu: dataDongLai.PaidID });
          userApi.getCurrentUser().then((dataUser) => {
            if (dataUser.status === 200) {
              objGhiChu.Id = 0;
              objGhiChu.GhiChu = "";
              objGhiChu.NguoiTao = dataUser.data.UserName;
              objGhiChu.PaidId = dataDongLai.PaidID;
              this.setState({ objGhiChu });
            }
            console.log(dataUser, "vvvvvvvv");
          });
          if (dataDongLai.isShowGhiChu) {
            dataDongLai.isShowGhiChu = !dataDongLai.isShowGhiChu;
          } else {
            dataDongLai.isShowGhiChu = true;
          }
        } else {
          dataDongLai.isShowGhiChu = false;
        }
        return dataDongLai;
      });
  };

  editGhiChu = (item, index) => () => {
    let objGhiChu = this.state.dataGhiChu;
    userApi.getCurrentUser().then((dataUser) => {
      if (dataUser.status === 200) {
        objGhiChu.Id = item.Id;
        objGhiChu.PaidId = item.PaidId;
        objGhiChu.GhiChu = item.GhiChu;
        objGhiChu.NguoiTao = dataUser.data.UserName;
        objGhiChu.NgayTao = new Date();
        this.setState({ objGhiChu });
      }
    });
  };

  updateTextValue = (field) => (evt) => {
    let objGhiChu = this.state.dataGhiChu;
    objGhiChu.GhiChu = evt.target.value;
    this.setState({ objGhiChu });
  };
  addGhiChu = () => {
    console.log(this.state.dataGhiChu, "2hhhhhhhhhhhhhh");
    const value = this.state.dataGhiChu;
    if (value.GhiChu === "") {
      pushNotification(
        "Bạn chưa nhập nội dung ghi chú",
        "error",
        "TOP_CENTER",
        1000,
      );
      return;
    }
    if (value.Id > 0) {
      const param2 = value;
      var params = param2;
      TraGopApi.addGhiChu(params).then((response) => {
        if (response.status == 200) {
          TraGopApi.ChiTietGhiChu(value.PaidId).then((response) => {
            if (response.status === 200) {
              this.setState({ listGhiChu: response.data });
            }
          });
          pushNotification(
            "Cập nhật ghi chú thành công",
            "success",
            "TOP_CENTER",
            1000,
          );
          value.Id = 0;
          // value.PaidId = 0;
          value.GhiChu = "";
          value.NgayTao = new Date();
          this.setState({ value });
        } else {
          pushNotification(response.data, "error", "TOP_CENTER", 1000);
        }
      });
    } else {
      const param2 = value;
      var params = param2;
      TraGopApi.addGhiChu(params).then((response) => {
        if (response.status == 200) {
          TraGopApi.ChiTietGhiChu(value.PaidId).then((response) => {
            if (response.status === 200) {
              this.setState({ listGhiChu: response.data });
            }
          });
          pushNotification(
            "Thêm ghi chú thành công",
            "success",
            "TOP_CENTER",
            1000,
          );
          value.Id = 0;
          // value.PaidId = 0;
          value.GhiChu = "";
          value.NgayTao = new Date();
          this.setState({ value });
        } else {
          pushNotification(response.data, "error", "TOP_CENTER", 1000);
        }
      });
    }
  };
  renderRow(List) {
    let {
      editItem,
      itemShow,
      phiPhat,
      dataGhiChu,
      isCauHinhT86,
      objThietLapHienThiDanhSach,
    } = this.state;
    let { GhiChu, Id } = dataGhiChu;
    let {
      onShowPhieuThu,
      thaydoitienlai,
      data,
      xoaphieuthuchi,
      isShowPhiKho,
      quanlychovay,
      showPhiPhat,
      SuDungPhiPhat_DongLai_TatToan,
      SuDungPhiPhat_DongLai_Cham,
    } = this.props;
    let { Type, StatusPaidHo, IsDuNoGiamDan } = data;
    console.log("thaydoitienlai", thaydoitienlai, "Type", Type);
    let choPhepXoa = true;
    let { totalRow } = quanlychovay.objListDonglai;
    return List.map((item, index) => {
      let daThanhToan =
        // (item.Status === 1 || item.Status === 2) &&
        (item.Status === 1 || item.Status === 2) &&
        Math.round((item.Paided - item.ValuePaid - item.ValueGoc) * 100) /
          100 >=
          0;
      let lstTP = [];
      let thuId = 0;
      let { ThuPaid, ThuChiId, PaidIdMax, IndexId, PaidID } = item;
      if (ThuPaid) lstTP = ThuPaid.split(",");
      if (daThanhToan) {
        choPhepXoa = xoaphieuthuchi;
      }
      let valueGop =
        item.ValueGop != undefined &&
        item.ValueGop != null &&
        item.ValueGop >= 0
          ? item.ValueGop
          : item.ValuePaid + item.ValueGoc;

      return (
        <>
          <div class="custom-table-row" key={"LanDongLai" + index}>
            {objThietLapHienThiDanhSach.IsAnSTT != true && (
              <div class="custom-table-cell username-cell flex-basis-5 disk-mobile">
                <span class="mobile-column-name color7">STT</span>
                <div class="center-wrapper">
                  <p class="text-center">{IndexId}</p>
                </div>
              </div>
            )}

            <div class="row-show-three">
              <div class="row-mobile">
                {objThietLapHienThiDanhSach.IsAnNgayTraLai != true && (
                  <div class="custom-table-cell flex-basis-8 flex-basis-5-responsive ">
                    <span class="mobile-column-name disk-mobile color7">
                      Ngày trả lãi
                    </span>
                    <div
                      class="center-wrapper"
                      style={{ display: "flex", alignItems: "center" }}
                    >
                      <p
                        class="icon-dropdown-mobile"
                        onClick={this.showRow(item)}
                        style={{ minWidth: "75px" }}
                      >
                        <i class="mdi mdi-arrow-down-drop-circle collapsible"></i>
                        {getDate(item.Time)}
                      </p>
                      {this.state.isShowGhiChuTraGop === true && Type === 2 && (
                        <a
                          className="icon-note-donglai"
                          onClick={this.setGhiChuShow(item, index, List)}
                          href={() => false}
                        >
                          <PopoversBootrap
                            contentText="Ghi chú"
                            titleText=""
                            trigger={["hover", "focus"]}
                            placement={"top"}
                          >
                            <i className="mdi mdi-notebook"></i>
                          </PopoversBootrap>
                        </a>
                      )}
                    </div>
                  </div>
                )}
                {objThietLapHienThiDanhSach.IsAnCanThanhToan != true && (
                  <div class="custom-table-cell flex-basis-8 flex-basis-13-sm flex-disk disk-desktop show-mobile">
                    <span class="mobile-column-name disk-mobile color7">
                      Cần thanh toán
                    </span>
                    <div class="center-wrapper">
                      <div class="center-wrapper">
                        <p class="text-can-tt">
                          {formatNumber2(
                            item.ValueGoc +
                              item.ValuePaid +
                              (item.OtheFee ? +item.OtheFee : 0) +
                              (item.Amercement ? +item.Amercement : 0) +
                              (item.PhiKho == null ? 0 : item.PhiKho) +
                              (item.OtheFeeHangKy == null
                                ? 0
                                : item.OtheFeeHangKy) +
                              (item.PhiPhatDongLai == null
                                ? 0
                                : item.PhiPhatDongLai),
                          )}{" "}
                        </p>
                      </div>
                    </div>
                  </div>
                )}
                {(StatusPaidHo !== 1 || Type !== 2) && Type !== 5 && (
                  <>
                    {objThietLapHienThiDanhSach.IsAnTienLai != true &&
                      (IsDuNoGiamDan == false ||
                        IsDuNoGiamDan == undefined) && (
                        <>
                          <div class="custom-table-cell flex-basis-8 flex-basis-13-sm flex-disk disk-mobile">
                            <span class="mobile-column-name disk-mobile color7">
                              Tiền lãi
                            </span>
                            <div class="center-wrapper">
                              {item === editItem &&
                                lstTP.length === 0 &&
                                thaydoitienlai && (
                                  <div className="mar-r20">
                                    <input
                                      type="text"
                                      class="form-control input-sm text-right"
                                      placeholder=""
                                      value={formatNumber2(editItem.ValuePaid)}
                                      onChange={this.onChangeValuePaidEdit(
                                        "ValuePaid",
                                      )}
                                      onKeyDown={this.handleKeyDown}
                                      onBlur={this.onblurValuePaid()}
                                    />
                                  </div>
                                )}
                              {totalRow !== item.IndexId &&
                                item !== editItem &&
                                lstTP.length === 0 &&
                                thaydoitienlai === true &&
                                (item.ValueGoc === 0 ||
                                  ((Type === 1 || Type === 2 || Type === 5) &&
                                    item.ValuePaid > 0)) && (
                                  <p class="text-right">
                                    <a
                                      href={() => false}
                                      onClick={this.setEditItem(item)}
                                    >
                                      {formatNumber2(item.ValuePaid)}
                                    </a>
                                  </p>
                                )}
                              {(lstTP.length > 0 ||
                                totalRow === item.IndexId ||
                                thaydoitienlai !== true ||
                                (item.ValueGoc > 0 &&
                                  item.ValuePaid === 0)) && (
                                <p class="text-right">
                                  {formatNumber2(item.ValuePaid)}
                                </p>
                              )}
                            </div>
                          </div>
                        </>
                      )}
                    {objThietLapHienThiDanhSach.IsAnTienGop != true &&
                      IsDuNoGiamDan == true && (
                        <>
                          <div class="custom-table-cell flex-basis-8 flex-basis-13-sm flex-disk disk-mobile">
                            <span class="mobile-column-name disk-mobile color7">
                              Tiền góp
                            </span>
                            <div class="center-wrapper">
                              {item === editItem &&
                                lstTP.length === 0 &&
                                thaydoitienlai && (
                                  <div className="mar-r20">
                                    <input
                                      type="text"
                                      class="form-control input-sm text-right"
                                      placeholder=""
                                      value={formatNumber2(item.ValuePaid)}
                                      onChange={this.onChangeValuePaidEdit(
                                        "ValueGoc",
                                      )}
                                      onKeyDown={this.handleKeyDownValueGoc}
                                      onBlur={this.onblurValueGoc()}
                                    />
                                  </div>
                                )}
                              {totalRow !== item.IndexId &&
                                item !== editItem &&
                                lstTP.length === 0 &&
                                thaydoitienlai === true && (
                                  <p class="text-right">
                                    <a
                                      href={() => false}
                                      onClick={this.setEditItem(item)}
                                    >
                                      {formatNumber2(item.ValuePaid)}
                                    </a>
                                  </p>
                                )}
                              {(lstTP.length > 0 ||
                                totalRow === item.IndexId ||
                                thaydoitienlai !== true) && (
                                <p class="text-right">
                                  {formatNumber2(item.ValuePaid)}
                                </p>
                              )}
                            </div>
                          </div>
                        </>
                      )}
                  </>
                )}

                {objThietLapHienThiDanhSach.IsAnTienGop != true &&
                  StatusPaidHo === 1 &&
                  (Type === 2 || Type === 5) && (
                    <div class="custom-table-cell flex-basis-8 flex-basis-13-sm  disk-desktop show-mobile">
                      <span class="mobile-column-name disk-mobile color7">
                        Tiền góp
                      </span>
                      <div class="center-wrapper">
                        {item === editItem &&
                          lstTP.length === 0 &&
                          thaydoitienlai &&
                          (Type === 2 || Type === 5) && (
                            <div className="mar-r20">
                              <input
                                type="text"
                                class="form-control input-sm text-right"
                                placeholder=""
                                value={formatNumber2(valueGop)}
                                onChange={this.onChangeValuePaidEdit(
                                  "ValueGop",
                                )}
                                onKeyDown={this.handleKeyDownValueGop}
                                onBlur={this.onblurValueGop()}
                              />
                            </div>
                          )}
                        {totalRow !== item.IndexId &&
                          item !== editItem &&
                          lstTP.length === 0 &&
                          thaydoitienlai === true &&
                          (Type === 2 || Type === 5) && (
                            <p class="text-right">
                              <a
                                href={() => false}
                                onClick={this.setEditItem(item)}
                              >
                                {formatNumber2(valueGop)}
                              </a>
                            </p>
                          )}
                        {(lstTP.length > 0 ||
                          totalRow === item.IndexId ||
                          thaydoitienlai !== true ||
                          (Type !== 2 && Type !== 5)) && (
                          <p class="text-right">{formatNumber2(valueGop)}</p>
                        )}
                      </div>
                    </div>
                  )}
              </div>
              <div
                class="form-row-detail content12"
                style={{
                  display:
                    itemShow.isShow &&
                    (!itemShow.item || itemShow.item === item)
                      ? itemShow.displayText
                      : "none",
                }}
              >
                {(StatusPaidHo !== 1 || Type !== 2) && Type !== 5 && (
                  <>
                    {objThietLapHienThiDanhSach.IsAnTienLai != true &&
                      (IsDuNoGiamDan == false ||
                        IsDuNoGiamDan == undefined) && (
                        <>
                          <div class="custom-table-cell flex-basis-8 flex-basis-13-sm  disk-desktop show-mobile">
                            <span class="mobile-column-name">Tiền lãi</span>
                            <div class="center-wrapper">
                              {item === editItem &&
                                lstTP.length === 0 &&
                                thaydoitienlai && (
                                  <div className="mar-r20">
                                    <input
                                      type="text"
                                      class="form-control input-sm text-right"
                                      placeholder=""
                                      value={formatNumber2(editItem.ValuePaid)}
                                      onChange={this.onChangeValuePaidEdit(
                                        "ValuePaid",
                                      )}
                                      onKeyDown={this.handleKeyDown}
                                      onBlur={this.onblurValuePaid()}
                                    />
                                  </div>
                                )}
                              {totalRow !== item.IndexId &&
                                item !== editItem &&
                                lstTP.length === 0 &&
                                thaydoitienlai === true &&
                                (item.ValueGoc === 0 ||
                                  ((Type === 2 || Type === 5) &&
                                    item.ValuePaid > 0)) && (
                                  <p class="text-right">
                                    <a
                                      href={() => false}
                                      onClick={this.setEditItem(item)}
                                    >
                                      {formatNumber2(item.ValuePaid)}
                                    </a>
                                  </p>
                                )}
                              {(lstTP.length > 0 ||
                                totalRow === item.IndexId ||
                                thaydoitienlai !== true ||
                                (item.ValueGoc > 0 &&
                                  item.ValuePaid === 0)) && (
                                <p class="text-right">
                                  {formatNumber2(item.ValuePaid)}
                                </p>
                              )}
                            </div>
                          </div>
                        </>
                      )}
                    {objThietLapHienThiDanhSach.IsAnTienGop != true &&
                      IsDuNoGiamDan == true && (
                        <>
                          <div class="custom-table-cell flex-basis-8 flex-basis-13-sm  disk-desktop show-mobile">
                            <span class="mobile-column-name">Tiền góp</span>
                            <div class="center-wrapper">
                              {item === editItem &&
                                lstTP.length === 0 &&
                                thaydoitienlai && (
                                  <div className="mar-r20">
                                    <input
                                      type="text"
                                      class="form-control input-sm text-right"
                                      placeholder=""
                                      value={formatNumber2(item.ValuePaid)}
                                      onChange={this.onChangeValuePaidEdit(
                                        "ValueGoc",
                                      )}
                                      onKeyDown={this.handleKeyDownValueGoc}
                                      onBlur={this.onblurValueGoc()}
                                    />
                                  </div>
                                )}
                              {totalRow !== item.IndexId &&
                                item !== editItem &&
                                lstTP.length === 0 &&
                                thaydoitienlai === true && (
                                  <p class="text-right">
                                    <a
                                      href={() => false}
                                      onClick={this.setEditItem(item)}
                                    >
                                      {formatNumber2(item.ValuePaid)}
                                    </a>
                                  </p>
                                )}
                              {(lstTP.length > 0 ||
                                totalRow === item.IndexId ||
                                thaydoitienlai !== true) && (
                                <p class="text-right">
                                  {formatNumber2(item.ValuePaid)}
                                </p>
                              )}
                            </div>
                          </div>
                        </>
                      )}
                  </>
                )}

                {objThietLapHienThiDanhSach.IsAnTienGop != true &&
                  StatusPaidHo === 1 &&
                  (Type === 2 || Type === 5) && (
                    <div class="custom-table-cell flex-basis-8 flex-basis-13-sm  disk-desktop show-mobile">
                      <span class="mobile-column-name">Tiền góp</span>
                      <div class="center-wrapper">
                        {item === editItem &&
                          lstTP.length === 0 &&
                          thaydoitienlai &&
                          (Type === 2 || Type === 5) && (
                            <div className="mar-r20">
                              <input
                                type="text"
                                class="form-control input-sm text-right"
                                placeholder=""
                                value={formatNumber2(valueGop)}
                                onChange={this.onChangeValuePaidEdit(
                                  "ValueGop",
                                )}
                                onKeyDown={this.handleKeyDownValueGop}
                                onBlur={this.onblurValueGop()}
                              />
                            </div>
                          )}
                        {totalRow !== item.IndexId &&
                          item !== editItem &&
                          lstTP.length === 0 &&
                          thaydoitienlai === true &&
                          (Type === 2 || Type === 5) && (
                            <p class="text-right">
                              <a
                                href={() => false}
                                onClick={this.setEditItem(item)}
                              >
                                {formatNumber2(valueGop)}
                              </a>
                            </p>
                          )}
                        {(lstTP.length > 0 ||
                          totalRow === item.IndexId ||
                          thaydoitienlai !== true ||
                          (Type !== 2 && Type !== 5)) && (
                          <p class="text-right">{formatNumber2(valueGop)}</p>
                        )}
                      </div>
                    </div>
                  )}
                {isCauHinhT86 == false &&
                  objThietLapHienThiDanhSach.IsAnPhiHangKy != true && (
                    <div class="custom-table-cell flex-basis-8 flex-basis-13-sm ">
                      <span class="mobile-column-name color7">Phí hàng kỳ</span>
                      <div class="center-wrapper">
                        <p class="text-right">
                          <BtnPhiHangKy item={item} Type={Type} />
                        </p>
                      </div>
                    </div>
                  )}

                {objThietLapHienThiDanhSach.IsAnTienGoc != true &&
                  (StatusPaidHo !== 1 || (Type !== 2 && Type !== 5)) && (
                    <div class="custom-table-cell flex-basis-8 flex-basis-13-sm ">
                      <span class="mobile-column-name color7">Tiền gốc</span>
                      <div class="center-wrapper">
                        {item === editItem &&
                          lstTP.length === 0 &&
                          thaydoitienlai &&
                          (Type === 2 || Type === 5) && (
                            <div className="mar-r20">
                              <input
                                type="text"
                                class="form-control input-sm text-right"
                                placeholder=""
                                value={formatNumber2(editItem.ValueGoc)}
                                onChange={this.onChangeValuePaidEdit(
                                  "ValueGoc",
                                )}
                                onKeyDown={this.handleKeyDownValueGoc}
                                onBlur={this.onblurValueGoc()}
                              />
                            </div>
                          )}
                        {totalRow !== item.IndexId &&
                          item !== editItem &&
                          lstTP.length === 0 &&
                          thaydoitienlai === true &&
                          (Type === 2 || Type === 5) && (
                            <p class="text-right">
                              <a
                                href={() => false}
                                onClick={this.setEditItem(item)}
                              >
                                {formatNumber2(item.ValueGoc)}
                              </a>
                            </p>
                          )}
                        {(lstTP.length > 0 ||
                          totalRow === item.IndexId ||
                          thaydoitienlai !== true ||
                          (Type !== 2 && Type !== 5)) && (
                          <p class="text-right">
                            {formatNumber2(item.ValueGoc)}
                          </p>
                        )}
                        {/* <p class="text-right">{formatNumber2(item.ValueGoc)}</p> */}
                      </div>
                    </div>
                  )}
                {objThietLapHienThiDanhSach.IsAnPhiKhac != true && (
                  <div class="custom-table-cell flex-basis-10 flex-basis-10-responsive ">
                    <span class="mobile-column-name color7">Phí khác</span>
                    <div class="center-wrapper">
                      <p class="text-right">{formatNumber2(item.OtheFee)}</p>
                    </div>
                  </div>
                )}
                {objThietLapHienThiDanhSach.IsAnPhiKho != true &&
                  isShowPhiKho === 1 &&
                  Type == 3 &&
                  isCauHinhT86 == false && (
                    <div class="custom-table-cell flex-basis-10 flex-basis-10-responsive ">
                      <span class="mobile-column-name color7">Phí kho</span>
                      <div class="center-wrapper">
                        <p class="text-right">{formatNumber2(item.PhiKho)}</p>
                      </div>
                    </div>
                  )}
                {objThietLapHienThiDanhSach.IsAnPhiChamDongLaiTatToan != true &&
                  SuDungPhiPhat_DongLai_Cham && (
                    <>
                      <div class="custom-table-cell flex-basis-10 flex-basis-10-responsive ">
                        <span class="mobile-column-name color7">
                          Phí phạt chậm đóng lãi
                        </span>
                        <div class="center-wrapper">
                          <p class="text-right">
                            {formatNumber2(item.PhiDongLaiCham)}
                          </p>
                        </div>
                      </div>
                    </>
                  )}
                {objThietLapHienThiDanhSach.IsAnPhiChamDongLaiTatToan1 !=
                  true &&
                  SuDungPhiPhat_DongLai_TatToan && (
                    <>
                      <div class="custom-table-cell flex-basis-10 flex-basis-10-responsive ">
                        <span class="mobile-column-name color7">
                          Phạt chậm đóng lãi
                        </span>
                        <div class="center-wrapper">
                          <p class="text-right">
                            {formatNumber2(item.PhiPhatDongLai)}
                          </p>
                        </div>
                      </div>
                    </>
                  )}
                {objThietLapHienThiDanhSach.IsAnPhiPhat != true &&
                  showPhiPhat && (
                    <div class="custom-table-cell flex-basis-10 flex-basis-10-responsive">
                      <span class="mobile-column-name color7">Phí phạt</span>
                      <div class="center-wrapper">
                        <p class="text-right">
                          {formatNumber2(item.Amercement)}
                        </p>
                        {/* {lstTP.length > 0 && (
                          <p class="text-right">
                            {formatNumber2(item.Amercement)}
                          </p>
                        )} */}
                        {/* {lstTP.length === 0 && (
                          <div className="mar-r20">
                            <input
                              type="text"
                              class="form-control input-sm text-right"
                              placeholder=""
                              value={
                                phiPhat[PaidID]
                                  ? formatNumber2(phiPhat[PaidID])
                                  : formatNumber2(item.Amercement)
                              }
                              onChange={this.onChangePhiPhat(PaidID)}
                              onKeyDown={this.handleKeyDownPhiPhat(PaidID)}
                              onBlur={this.onblurPhiPhat(PaidID)}
                            />
                          </div>
                        )} */}
                      </div>
                    </div>
                  )}
                {objThietLapHienThiDanhSach.IsAnKhoanVay != true &&
                  (data.StatusPaidHo === 3 ||
                    data.IsDuNoGiamDan === true ||
                    data.IsKieuTraGocLai === true) && (
                    <div class="custom-table-cell flex-basis-8 flex-basis-13-sm ">
                      <span class="mobile-column-name color7">Khoản vay</span>
                      <div class="center-wrapper">
                        <p class="text-right">{formatNumber2(item.KhoanVay)}</p>
                      </div>
                    </div>
                  )}
                {objThietLapHienThiDanhSach.IsAnNoGocConLai != true &&
                  (data.StatusPaidHo === 3 ||
                    data.IsDuNoGiamDan === true ||
                    data.IsKieuTraGocLai === true) && (
                    <div class="custom-table-cell flex-basis-8 flex-basis-13-sm ">
                      <span class="mobile-column-name color7">
                        Nợ gốc còn lại
                      </span>
                      <div class="center-wrapper">
                        <p class="text-right">
                          {formatNumber2(item.NoGocConLai)}
                        </p>
                      </div>
                    </div>
                  )}
                {objThietLapHienThiDanhSach.IsAnCanThanhToan != true && (
                  <div class="custom-table-cell flex-basis-8 flex-basis-13-sm  disk-mobile">
                    <span class="mobile-column-name color7">
                      Cần thanh toán
                    </span>
                    <div class="center-wrapper">
                      <p class="text-can-tt">
                        {formatNumber2(
                          item.ValueGoc +
                            item.ValuePaid +
                            (item.OtheFee ? +item.OtheFee : 0) +
                            (item.Amercement ? +item.Amercement : 0) +
                            (item.PhiKho == null ? 0 : item.PhiKho) +
                            (item.OtheFeeHangKy == null
                              ? 0
                              : item.OtheFeeHangKy) +
                            (item.PhiPhatDongLai == null
                              ? 0
                              : item.PhiPhatDongLai) +
                            (item.PhiDongLaiCham == null
                              ? 0
                              : item.PhiDongLaiCham),
                        )}
                      </p>
                    </div>
                  </div>
                )}
                {objThietLapHienThiDanhSach.IsAnDaThanhToan != true && (
                  <div class="custom-table-cell flex-basis-8 flex-basis-13-sm ">
                    <span class="mobile-column-name color7">Đã thanh toán</span>
                    <div class="center-wrapper">
                      <p class="text-right">
                        {formatNumber2(
                          item.Paided +
                            (item.OtheFee == null ? 0 : item.OtheFee) +
                            (item.PhiKho == null ? 0 : item.PhiKho) +
                            (item.PhiPhatDongLai == null
                              ? 0
                              : item.PhiPhatDongLai) +
                            (item.PhiDongLaiCham == null
                              ? 0
                              : item.PhiDongLaiCham),
                        )}
                      </p>
                    </div>
                  </div>
                )}
                {objThietLapHienThiDanhSach.IsAnConPhaiTra != true && (
                  <div class="custom-table-cell flex-basis-8 flex-basis-13-sm ">
                    <span class="mobile-column-name color7">Còn phải trả</span>
                    <div class="center-wrapper">
                      <p class="text-right">
                        {formatNumber2(
                          item.ValueGoc +
                            item.ValuePaid +
                            (item.OtheFee ? +item.OtheFee : 0) +
                            (item.Amercement ? +item.Amercement : 0) +
                            (item.PhiKho == null ? 0 : item.PhiKho) +
                            (item.OtheFeeHangKy == null
                              ? 0
                              : item.OtheFeeHangKy) +
                            (item.PhiPhatDongLai == null
                              ? 0
                              : item.PhiPhatDongLai) +
                            (item.PhiDongLaiCham == null
                              ? 0
                              : item.PhiDongLaiCham) -
                            (item.Paided +
                              (item.OtheFee ? +item.OtheFee : 0) +
                              (item.PhiKho == null ? 0 : item.PhiKho) +
                              (item.PhiPhatDongLai == null
                                ? 0
                                : item.PhiPhatDongLai) +
                              (item.PhiDongLaiCham == null
                                ? 0
                                : item.PhiDongLaiCham)),
                        )}
                      </p>
                    </div>
                  </div>
                )}
                {objThietLapHienThiDanhSach.IsAnCacLanDong != true && (
                  <div class="custom-table-cell flex-basis-14 flex-basis-16-sm ">
                    <span class="mobile-column-name color7">Các lần đóng</span>
                    <div class="center-wrapper">
                      {lstTP.map((itemPaid, idexTP) => {
                        let itemPaids = itemPaid.split("#");
                        thuId = parseFloat(itemPaids[0]);
                        let showDongLai = "True";
                        if (itemPaids.length > 3) {
                          showDongLai = itemPaids[3] == "True";
                        }
                        let showDelete =
                          idexTP === lstTP.length - 1 &&
                          PaidIdMax === item.PaidID &&
                          choPhepXoa;

                        return (
                          <div className=" d-flex form-mobile-donglai">
                            {showDongLai && (
                              <p class="text-center btn-link color-xanh">
                                <a
                                  href={() => false}
                                  onClick={onShowPhieuThu(thuId)}
                                >
                                  {formatNumber2(itemPaids[2]).replace(
                                    ".00",
                                    "",
                                  )}
                                </a>

                                <span class="date-sm">
                                  ({getDate(itemPaids[1])})
                                </span>
                              </p>
                            )}
                            {showDelete &&
                              this.state.HasTatToanChoDuyet !== 1 && (
                                <>
                                  <button
                                    className="btn-donglai-xoa"
                                    onClick={this.deletethanhToan(
                                      itemPaids[2],
                                      thuId,
                                    )}
                                  >
                                    <PopoversBootrap
                                      contentText="Xoá"
                                      trigger={["hover", "focus"]}
                                      placement={"top"}
                                    >
                                      <i class="fas fa-trash"></i>
                                    </PopoversBootrap>
                                  </button>
                                </>
                              )}
                          </div>
                        );
                      })}
                    </div>
                  </div>
                )}
              </div>
              {objThietLapHienThiDanhSach.IsAnThaoTac != true &&
                this.state.HasTatToanChoDuyet !== 1 && (
                  <div class="custom-table-cell flex-basis-5 flex-basis-2-sm   sticky-icon sticky-col-new first-col-new">
                    <div class="center-wrapper">
                      <div class="inputTableMorman text-can-tt">
                        <div
                          className={
                            "b-checkbox is-danger " +
                            (item.ValueGoc > 0 &&
                            Type !== 1 &&
                            Type !== 2 &&
                            Type !== 5 &&
                            (IsDuNoGiamDan == false ||
                              IsDuNoGiamDan == undefined)
                              ? //||(totalRow === index + 1 && Type === 2) || (Type === 3 && IsDuNoGiamDan == true && totalRow === index + 1)
                                "hidden"
                              : "")
                          }
                        >
                          {choPhepXoa && daThanhToan && (
                            <input
                              id="checkbox1"
                              class="styled"
                              type="checkbox"
                              checked={daThanhToan}
                              disabled={
                                parseFloat(ThuChiId) !== thuId && ThuPaid
                              }
                              onClick={this.thanhToan(item.Value, thuId)}
                            />
                          )}
                          {!choPhepXoa && daThanhToan && (
                            <input
                              id="checkbox1"
                              class="styled"
                              type="checkbox"
                              checked={daThanhToan}
                              disabled={true}
                              onClick={this.thanhToan(item.Value, thuId)}
                            />
                          )}
                          {!daThanhToan && (
                            <input
                              id="checkbox1"
                              class="styled"
                              type="checkbox"
                              checked={false}
                              onClick={this.thanhToan(item.Value, thuId)}
                            />
                          )}
                          <label for="checkbox1"></label>
                        </div>
                      </div>
                    </div>
                  </div>
                )}
            </div>
          </div>

          {/* Start Ghi chú form trả góp */}
          {this.state.isEditGhiChu === item.PaidID &&
            item.isShowGhiChu === true && (
              <div class="custom-table-row newTable">
                <div className="form-note-tg">
                  <div class="row">
                    <div class="col-xl-6 col-lg-12">
                      <div class="form-group row">
                        <label class="col-md-4 label-control">
                          Ghi chú<span class="canh-bao-red">*</span>
                        </label>
                        <div class="col-md-8">
                          <textarea
                            rows="2"
                            className="form-control input-sm"
                            value={GhiChu}
                            onChange={this.updateTextValue("GhiChu")}
                            placeholder=""
                          ></textarea>
                        </div>
                      </div>
                      <div class="text-right">
                        <button
                          type="button"
                          class="btn btn-new-main btn-checknew"
                          onClick={this.addGhiChu}
                        >
                          <span class="btn-icon-left">
                            <i class="mdi mdi-check-underline-circle"></i>
                          </span>
                          {Id > 0 ? "Cập nhật ghi chú" : "Lưu ghi chú"}
                        </button>
                      </div>
                    </div>
                    <div class="col-xl-6 col-lg-12">
                      <div className="scroll-detail">
                        {this.state.listGhiChu.length > 0 &&
                          this.state.listGhiChu.map((itemDetail, ii) => {
                            return (
                              <div className="row-note">
                                <div className="date-note">
                                  {itemDetail.NgayTao}
                                </div>
                                <div>
                                  <div>Nội dung: {itemDetail.GhiChu}</div>
                                  <div>
                                    Bởi: {itemDetail.NguoiTao}{" "}
                                    <a
                                      href={() => false}
                                      onClick={this.editGhiChu(itemDetail, ii)}
                                    >
                                      <PopoversBootrap
                                        contentText="Sửa"
                                        titleText=""
                                        trigger={["hover", "focus"]}
                                        placement={"top"}
                                      >
                                        <i className="mdi mdi-pencil-circle"></i>
                                      </PopoversBootrap>
                                    </a>
                                  </div>
                                </div>
                              </div>
                            );
                          })}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}

          {/* End */}
        </>
      );
    });
  }
  renderRowPhiKhac() {
    let { data } = this.props;
    let { lstPhiKhac } = this.state;
    return lstPhiKhac.map((item, index) => {
      return (
        <div class="custom-table-row">
          <div class="custom-table-cell username-cell flex-basis-5 disk-mobile">
            <span class="mobile-column-name color7">STT</span>
            <div class="center-wrapper">
              <p class="text-center">{index + 1}</p>
            </div>
          </div>
          <div class="row-show-three">
            <div class="row-mobile">
              <div class="custom-table-cell flex-basis-5 disk-mobile">
                <span class="mobile-column-name color7">Thời gian</span>
                <div class="center-wrapper">
                  <p class="icon-dropdown-mobile text-center">
                    <i class="mdi mdi-arrow-down-drop-circle collapsible"></i>
                    {getDate(data.UpdatedTime)}
                  </p>
                </div>
              </div>
              <div class="custom-table-cell flex-basis-15 disk-mobile">
                <span class="mobile-column-name color7 ">Tên</span>
                <div class="center-wrapper">
                  <p>{item.TenPhiKhac}</p>
                </div>
              </div>
              <div class="custom-table-cell flex-basis-5 disk-mobile">
                <span class="mobile-column-name color7 ">LS Phí</span>
                <p class="text-right1">{item.GiaTri}</p>
              </div>
              <div class="custom-table-cell flex-basis-10  disk-mobile">
                <span class="mobile-column-name color7">Tính theo</span>
                {item.LoaiPhiKhacChon == 1 ? (
                  <>
                    <div class="center-wrapper">
                      <p class="text-right1"> Tiền </p>
                    </div>
                  </>
                ) : (
                  <>
                    <div class="center-wrapper">
                      <p class="text-right1"> % </p>
                    </div>
                  </>
                )}
              </div>
              <div class="custom-table-cell flex-basis-10  disk-mobile">
                <span class="mobile-column-name color7">Tổng tiền</span>
                <div class="center-wrapper">
                  {item.LoaiPhiKhacChon == 1 ? (
                    <>
                      <div class="center-wrapper">
                        <p class="text-right1">
                          {" "}
                          {formatNumber(item.ThanhTien)}{" "}
                        </p>
                      </div>
                    </>
                  ) : (
                    <>
                      <div class="center-wrapper">
                        <p class="text-right1">
                          {" "}
                          {formatNumber(item.ThanhTien)}{" "}
                        </p>
                      </div>
                    </>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      );
    });
  }
  onChangeNumber = (field) => (evt) => {
    let { quanlythuchi, updateObjThanhToan } = this.props;
    let { objThanhToan } = quanlythuchi;
    objThanhToan[field] = convertToNumber(evt.target.value);
    updateObjThanhToan(objThanhToan);
  };
  onChangeText = (field) => (evt) => {
    let { quanlythuchi, updateObjThanhToan } = this.props;
    let { objThanhToan } = quanlythuchi;
    objThanhToan[field] = evt.target.value;
    updateObjThanhToan(objThanhToan);
  };
  onChangeCheckbox = () => (evt) => {
    let { quanlythuchi, updateObjThanhToan } = this.props;
    let { objThanhToan } = quanlythuchi;
    objThanhToan.DoiKy = !objThanhToan.DoiKy;
    updateObjThanhToan(objThanhToan);
  };
  onChangeDate = () => (evt) => {
    let { quanlythuchi, updateObjThanhToan, getLaiDenNgayChoVay, data } =
      this.props;
    let { objThanhToan } = quanlythuchi;
    objThanhToan.NgayThanhToan = formatDayMonth(evt);
    updateObjThanhToan(objThanhToan);
    getLaiDenNgayChoVay({
      choVayId: data.ChoVayId,
      toDate: objThanhToan.NgayThanhToan,
    });
    if (this.state.isWinmoney)
      this.loadPhiPhatTraCham(data.ChoVayId, objThanhToan.NgayThanhToan);
  };
  // Tiền phạt trả chậm = số ngày chưa đóng * gốc còn lại * đơn giá cấu hình phiPhatTraCham.
  // Giữ ở field riêng PhiPhatTraCham chứ không dùng chung ô PhiDongLaiCham: api lai-den-ngay
  // chạy song song và reducer của nó ghi đè PhiDongLaiCham, dùng chung sẽ bị mất số.
  // Backend cộng khoản này vào cột PhiDongLaiCham của ThuChi lúc lưu.
  // Số tiền chỉ điền sẵn, nhân viên vẫn sửa tay được trước khi thu.
  loadPhiPhatTraCham = (choVayId, toDate) => {
    QuanLyChoVayApi.phiPhatTraCham({ choVayId, toDate }).then((response) => {
      if (response.status === 200) {
        // Đọc props tại thời điểm api trả về, không dùng bản chụp lúc gọi: api lai-den-ngay
        // chạy song song và reducer của nó tạo objThanhToan mới, lấy bản cũ sẽ xoá mất kết quả đó.
        let { quanlythuchi, updateObjThanhToan } = this.props;
        let objThanhToan =
          (quanlythuchi && quanlythuchi.objThanhToan) ||
          this.state.objThanhToan;
        objThanhToan.PhiPhatTraCham = response.data.TienPhatTraCham ?? 0;
        this.setState({
          soNgayTraCham: response.data.SoNgay ?? 0,
          soNgayTinhPhat: response.data.SoNgayTinhPhat ?? 0,
        });
        updateObjThanhToan(objThanhToan);
      }
    });
  };
  showFormInMobile = () => {
    let { isShowFormDongLai } = this.state;
    this.setState({ isShowFormDongLai: !isShowFormDongLai });
  };
  _onSelectKenhThanhToan = () => (evt) => {
    let { quanlythuchi, updateObjThanhToan } = this.props;
    let { objThanhToan } = quanlythuchi;
    objThanhToan.KenhThanhToan = evt.target.value;
    updateObjThanhToan(objThanhToan);
  };

  // updateSelectBank = () => (e) => {
  //   this.setState({ bankId: e.target.value });
  // }
  // ShowQR = () => () => {

  //   let {
  //     quanlythuchi,
  //     data
  //   } = this.props;
  //   let { objThanhToan } = quanlythuchi;

  //   // SoTienDong: objThanhToan.SoTien,
  //   // PhiKho: objThanhToan.,
  //   // PhiKhac: objThanhToan.,
  //   // GhiChu: objThanhToan.GhiChu,
  //   // DoiKy: objThanhToan.DoiKy,
  //   // DongThemQuaHan: objThanhToan.soNgayQuanHan > 0,
  //   // SoTienPhaiDong: objThanhToan.SoTienPhaiDong,
  //   // KenhThanhToan: objThanhToan.KenhThanhToan,
  //   // PhiPhatTraLai: objThanhToan.,
  //   // PhiDongLaiCham: objThanhToan.,

  //   var tongtien = "";
  //   if (objThanhToan.SoTien > 0) {
  //     tongtien = " TTien" + objThanhToan.SoTien;
  //   }
  //   var phikho = "";
  //   if (objThanhToan.PhiKho > 0) {
  //     phikho = " PKho" + objThanhToan.PhiKho;
  //   }
  //   var PhiKhac = "";
  //   if (objThanhToan.PhiKhac > 0) {
  //     PhiKhac = " PKhac" + objThanhToan.PhiKhac;
  //   }
  //   var PhiPhatTraLai = "";
  //   if (objThanhToan.PhiPhatTraLai > 0) {
  //     PhiPhatTraLai = " PhiTL" + objThanhToan.PhiPhatTraLai;
  //   }
  //   var PhiDongLaiCham = "";
  //   if (objThanhToan.PhiDongLaiCham > 0) {
  //     PhiDongLaiCham = " PhiCham" + objThanhToan.PhiDongLaiCham;
  //   }
  //   var SoTienPhaiDong = "";
  //   if (objThanhToan.SoTienPhaiDong > 0) {
  //     SoTienPhaiDong = " PDong" + objThanhToan.SoTienPhaiDong;
  //   }

  //   let { imgUrlQR, IdCuaHang, lstBank, bankId } = this.state;
  //   let { } = this.props;
  //   if (bankId != "") {
  //     const bank = lstBank.find((z) => z.Id == bankId);
  //     var noidung = IdCuaHang + " " + data.ChoVayId + " ThanhToanHopDong" + data.Code.replace(" ", "") + tongtien + phikho + PhiKhac + PhiPhatTraLai + PhiDongLaiCham + SoTienPhaiDong;
  //     var url = "https://img.vietqr.io/image/" + bank.MaBin + "-" + bank.SoTaiKhoan + "-qr_only.png?amount=0&addInfo=" + noidung;
  //     this.setState({ imgUrlQR: url });
  //   }
  // }

  handleDownload = async () => {
    let { imgUrlQR } = this.state;
    let { data } = this.props;
    const response = await fetch(imgUrlQR);
    const blob = await response.blob();
    const blobUrl = URL.createObjectURL(blob);

    const link = document.createElement("a");
    link.href = blobUrl;
    link.download = "QR" + data.Code + ".png";
    link.click();

    URL.revokeObjectURL(blobUrl);
  };
  toggleModalThietLapHienThi() {
    this.setState({
      isShowModalThietLapHienThi: !this.state.isShowModalThietLapHienThi,
    });
  }
  setModalThietLapHienThi = () => () => {
    this.toggleModalThietLapHienThi();
  };
  render() {
    let props = this.props;
    let {
      data,
      quanlychovay,
      quanlythuchi,
      buttonLeft,
      cauhinh,
      show,
      phanquyen,
      chonngaygiaodich,
      xoaphieuthuchi,
      isShowPhiKho,
      showPhiPhat,
      cuahangdoitac,
      SuDungPhiPhat_DongLai_TatToan,
      SuDungPhiPhat_DongLai_Cham,
    } = this.props;
    let {
      List,
      TongCanThanhToan,
      TongPhiKhac,
      TongPhiKho,
      TongThanhToan,
      TongTienGoc,
      TongTienLai,
      TongPhiPhat,
      totalRow,
      TongPhiKhacHangKy,
      TongPhiPhatDongLai,
      TongPhiDongLaiCham,
    } = quanlychovay.objListDonglai;
    if (quanlychovay.objListDonglai.List.length != 0) {
      if (quanlychovay.objListDonglai.List[0].ChoVayID != data.ChoVayId) {
        List = [];
        TongCanThanhToan = 0;
        TongPhiKhac = 0;
        TongPhiKho = 0;
        TongThanhToan = 0;
        TongTienGoc = 0;
        TongTienLai = 0;
        TongPhiPhat = 0;
        totalRow = 0;
        TongPhiKhacHangKy = 0;
        TongPhiPhatDongLai = 0;
        TongPhiDongLaiCham = 0;
      }
    }
    let { getLanDongLaiChoVayLoading } = quanlychovay;
    let {
      dataSearch,
      isShowFormDongLai,
      totalPhiKhac,
      isCauHinhT86,
      isCauHinhT77,
      bankId,
      lstBank,
      isQRThanhToan,
      imgUrlQR,
      isCauHinhKhachHangVSNY,
      objThietLapHienThiDanhSach,
      soNgayTraCham,
      soNgayTinhPhat,
      isWinmoney,
    } = this.state;
    let {
      objThanhToan,
      postThanhToanChoVayLoading,
      deleteThanhToanChoVayLoading,
    } = quanlythuchi;
    let NgayThanhToan = objThanhToan.NgayThanhToan;
    if (NgayThanhToan) NgayThanhToan = convertDate(NgayThanhToan);
    let { soNgayQuanHan, ngayBatDau } = objThanhToan;
    let { combo } = cuahangdoitac;
    return (
      <Modal
        show={show}
        onHide={this.onHide}
        size="modal-xl-new modal-xl-new"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        className="modal-new modal fade text-left popup-detail"
      >
        <Modal.Header>
          <h4 className="modal-title color7-bold" id="myModalLabel16">
            <span className="btn-icon-right">
              <img src="/app-assets/images/icon-dong-lai-v2.png" />
            </span>
            <span style={{ marginLeft: "-20px", marginTop: "10px" }}>
              {" "}
              Đóng lãi{" "}
            </span>
          </h4>
          <button
            type="button"
            className="close-popup-new"
            onClick={props.onHide}
          >
            <i className="mdi mdi-close"></i>
          </button>
        </Modal.Header>
        <Modal.Body className="form-donglai-mobile">
          <div
            className={
              "loader loader-default " +
              (getLanDongLaiChoVayLoading ||
              postThanhToanChoVayLoading ||
              deleteThanhToanChoVayLoading
                ? "is-active"
                : "")
            }
          ></div>
          {this.state.HasTatToanChoDuyet === 1 && (
            <>
              <div className="row">
                <div className="col-md-12">
                  <div className="thongbaotattoan">
                    <i class="mdi mdi-alert" style={{ color: "#d39c00" }}></i>{" "}
                    HỢP ĐỒNG ĐANG CHỜ DUYỆT YÊU CẦU TẤT TOÁN
                  </div>
                </div>
              </div>
            </>
          )}
          <Tabs className="tabMorman">
            <Tab
              eventKey="chiTiet"
              title={<h4 className="tab-v2">Chi tiết đóng lãi</h4>}
            >
              <div>
                <button
                  type="button"
                  className="btn btn-border-new"
                  onClick={this.setModalThietLapHienThi()}
                >
                  <span>
                    <i className="fa fa-cog"></i>
                    <span className="btn-link color-xanh">
                      Thiết lập hiển thị
                    </span>
                  </span>
                </button>
              </div>
              <div class="detail-donglai">
                <div class="width-right-from order-lg-1 order-2 pt-1">
                  <div class="disk-desktop show-mobile  ">
                    <div class="title-ls-donglai">
                      <h4>
                        Lần trả lãi
                        <i class="mdi mdi-chevron-double-down"></i>
                      </h4>
                    </div>
                  </div>
                  <div class="table-from-new" style={{ marginBottom: "30px" }}>
                    <div class="Left808x200 Table-main-new table-mobile-new">
                      <div class="table-responsive table-responsive-new table-new1  table-rounded">
                        <div class="custom-table-wrapper">
                          <div class="table-headers">
                            {objThietLapHienThiDanhSach.IsAnSTT != true && (
                              <div class="custom-table-header flex-basis-5">
                                <p class="text-center">
                                  <span class="color-do-bold">
                                    [{totalRow}]
                                  </span>
                                  <br />
                                  &nbsp;
                                </p>
                              </div>
                            )}
                            {objThietLapHienThiDanhSach.IsAnNgayTraLai !=
                              true && (
                              <div class="custom-table-header flex-basis-8 flex-basis-5-responsive ">
                                <p>
                                  {data.Type === 5
                                    ? "Ngày trả"
                                    : "Ngày trả lãi"}{" "}
                                  <br />
                                  &nbsp;
                                </p>
                              </div>
                            )}

                            {objThietLapHienThiDanhSach.IsAnTienLai != true &&
                              (data.StatusPaidHo !== 1 || data.Type !== 2) &&
                              data.Type !== 5 && (
                                <div class="custom-table-header flex-basis-8 flex-basis-13-sm">
                                  <p class="text-right">
                                    Tiền lãi
                                    <br />
                                    <PopoversBootrap
                                      contentText={formatNumber2(TongTienLai)}
                                      trigger={["hover", "focus"]}
                                      placement={"bottom"}
                                    >
                                      <span class="color-cam-bold">
                                        &nbsp;{formatCurrency(TongTienLai)}
                                      </span>
                                    </PopoversBootrap>
                                  </p>
                                </div>
                              )}

                            {objThietLapHienThiDanhSach.IsAnTienGop != true &&
                              data.StatusPaidHo === 1 &&
                              data.Type === 2 && (
                                <div class="custom-table-cell flex-basis-8 flex-basis-13-sm  disk-desktop show-mobile">
                                  <p class="text-right">
                                    Tiền góp
                                    <br />
                                    <PopoversBootrap
                                      contentText={formatNumber2(
                                        TongTienGoc + TongTienLai,
                                      )}
                                      trigger={["hover", "focus"]}
                                      placement={"bottom"}
                                    >
                                      <span class="color-do-bold">
                                        {formatCurrency(
                                          TongTienGoc + TongTienLai,
                                        )}
                                      </span>
                                    </PopoversBootrap>
                                  </p>
                                </div>
                              )}
                            {isCauHinhT86 == false &&
                              objThietLapHienThiDanhSach.IsAnPhiHangKy !=
                                true && (
                                <div class="custom-table-header flex-basis-8 flex-basis-13-sm">
                                  <p class="text-right">
                                    Phí hàng kỳ <br />
                                    <span class="home-new-yellow">
                                      {formatNumber2(TongPhiKhacHangKy)}
                                    </span>
                                  </p>
                                </div>
                              )}

                            {objThietLapHienThiDanhSach.IsAnKyGop != true &&
                              data.Type == 5 && (
                                <div class="custom-table-header flex-basis-8 flex-basis-13-sm">
                                  <p class="text-right">
                                    Kỳ góp
                                    <br />{" "}
                                    <PopoversBootrap
                                      contentText={formatNumber2(TongTienGoc)}
                                      trigger={["hover", "focus"]}
                                      placement={"bottom"}
                                    >
                                      <span class="color-do-bold">
                                        &nbsp; {formatCurrency(TongTienGoc)}
                                      </span>
                                    </PopoversBootrap>
                                  </p>
                                </div>
                              )}
                            {objThietLapHienThiDanhSach.IsAnTienGoc != true &&
                              (data.StatusPaidHo !== 1 || data.Type !== 2) &&
                              data.Type !== 5 && (
                                <div class="custom-table-header flex-basis-8 flex-basis-13-sm">
                                  <p class="text-right">
                                    Tiền gốc
                                    <br />{" "}
                                    <PopoversBootrap
                                      contentText={formatNumber2(TongTienGoc)}
                                      trigger={["hover", "focus"]}
                                      placement={"bottom"}
                                    >
                                      <span class="color-do-bold">
                                        &nbsp;{" "}
                                        {isCauHinhT77
                                          ? formatCurrency2(TongTienGoc)
                                          : formatCurrency(TongTienGoc)}
                                      </span>
                                    </PopoversBootrap>
                                  </p>
                                </div>
                              )}
                            {objThietLapHienThiDanhSach.IsAnPhiKhac != true && (
                              <div class="custom-table-header flex-basis-10 flex-basis-10-responsive">
                                <p class="text-right">
                                  Phí khác
                                  <br />
                                  <PopoversBootrap
                                    contentText={formatNumber2(TongPhiKhac)}
                                    trigger={["hover", "focus"]}
                                    placement={"bottom"}
                                  >
                                    <span class="">
                                      {formatCurrency(TongPhiKhac)}
                                    </span>
                                  </PopoversBootrap>
                                </p>
                              </div>
                            )}
                            {objThietLapHienThiDanhSach.IsAnPhiKho != true &&
                              isShowPhiKho === 1 &&
                              data.Type == 3 &&
                              isCauHinhT86 == false && (
                                <div class="custom-table-header flex-basis-10 flex-basis-10-responsive">
                                  <p class="text-right">
                                    Phí kho
                                    <br />
                                    <span class="">
                                      {formatNumber2(TongPhiKho)}
                                    </span>
                                  </p>
                                </div>
                              )}
                            {objThietLapHienThiDanhSach.IsAnPhiChamDongLaiTatToan1 !=
                              true &&
                              SuDungPhiPhat_DongLai_TatToan && (
                                <div class="custom-table-header flex-basis-10 flex-basis-10-responsive">
                                  <p class="text-right">
                                    Phạt chậm đóng lãi
                                    <br />
                                    <PopoversBootrap
                                      contentText={formatNumber2(
                                        TongPhiPhatDongLai,
                                      )}
                                      trigger={["hover", "focus"]}
                                      placement={"bottom"}
                                    >
                                      <span class="">
                                        {formatCurrency(TongPhiPhatDongLai)}
                                      </span>
                                    </PopoversBootrap>
                                  </p>
                                </div>
                              )}
                            {objThietLapHienThiDanhSach.IsAnPhiChamDongLaiTatToan !=
                              true &&
                              SuDungPhiPhat_DongLai_Cham && (
                                <div class="custom-table-header flex-basis-10 flex-basis-10-responsive">
                                  <p class="text-right">
                                    Phí Phạt
                                    <br />
                                    <span class="">
                                      {formatNumber2(TongPhiDongLaiCham)}
                                    </span>
                                  </p>
                                </div>
                              )}

                            {objThietLapHienThiDanhSach.IsAnPhiPhat != true &&
                              showPhiPhat && (
                                <div class="custom-table-header flex-basis-10 flex-basis-10-responsive">
                                  <p class="text-right">
                                    Phí phạt
                                    <br />
                                    <PopoversBootrap
                                      contentText={formatNumber2(TongPhiPhat)}
                                      trigger={["hover", "focus"]}
                                      placement={"bottom"}
                                    >
                                      <span class="">
                                        {formatCurrency(TongPhiPhat)}
                                      </span>
                                    </PopoversBootrap>
                                  </p>
                                </div>
                              )}
                            {objThietLapHienThiDanhSach.IsAnKhoanVay != true &&
                              (data.StatusPaidHo === 3 ||
                                data.IsDuNoGiamDan === true ||
                                data.IsKieuTraGocLai === true) && (
                                <div class="custom-table-header flex-basis-8 flex-basis-13-sm">
                                  <p class="text-right">
                                    Khoản vay <br />
                                  </p>
                                </div>
                              )}
                            {objThietLapHienThiDanhSach.IsAnNoGocConLai !=
                              true &&
                              (data.StatusPaidHo === 3 ||
                                data.IsDuNoGiamDan === true ||
                                data.IsKieuTraGocLai === true) && (
                                <div class="custom-table-header flex-basis-8 flex-basis-13-sm">
                                  <p class="text-right">
                                    Nợ gốc còn lại <br />
                                  </p>
                                </div>
                              )}
                            {objThietLapHienThiDanhSach.IsAnCanThanhToan !=
                              true && (
                              <div class="custom-table-header flex-basis-8 flex-basis-13-sm">
                                <p class="text-right">
                                  Cần thanh toán <br />
                                  <PopoversBootrap
                                    contentText={formatNumber2(
                                      TongCanThanhToan +
                                        TongPhiKhac +
                                        TongPhiKho +
                                        TongPhiPhatDongLai,
                                    )}
                                    trigger={["hover", "focus"]}
                                    placement={"bottom"}
                                  >
                                    <span class="color-do-bold">
                                      {formatCurrency(
                                        TongCanThanhToan +
                                          TongPhiKhac +
                                          TongPhiKho +
                                          TongPhiPhatDongLai,
                                      )}
                                    </span>
                                  </PopoversBootrap>
                                </p>
                              </div>
                            )}
                            {objThietLapHienThiDanhSach.IsAnDaThanhToan !=
                              true && (
                              <div
                                class="custom-table-header flex-basis-8 flex-basis-13-sm"
                                style={{ minHeight: "82px" }}
                              >
                                <p class="text-right">
                                  Đã thanh toán <br />
                                  <PopoversBootrap
                                    contentText={formatNumber2(
                                      TongThanhToan +
                                        TongPhiKhac +
                                        TongPhiKho +
                                        TongPhiPhatDongLai,
                                    )}
                                    trigger={["hover", "focus"]}
                                    placement={"bottom"}
                                  >
                                    <span class="color-xanh-bold">
                                      {formatCurrency(
                                        TongThanhToan +
                                          TongPhiKhac +
                                          TongPhiKho +
                                          TongPhiPhatDongLai,
                                      )}
                                    </span>
                                  </PopoversBootrap>
                                </p>
                              </div>
                            )}
                            {objThietLapHienThiDanhSach.IsAnConPhaiTra !=
                              true && (
                              <div
                                class="custom-table-header flex-basis-8 flex-basis-13-sm"
                                style={{ minHeight: "82px" }}
                              >
                                <p class="text-right">
                                  Còn phải trả <br />
                                  <PopoversBootrap
                                    contentText={formatNumber2(
                                      TongCanThanhToan +
                                        TongPhiKhac +
                                        TongPhiKho +
                                        TongPhiPhatDongLai -
                                        (TongThanhToan +
                                          TongPhiKho +
                                          TongPhiPhatDongLai),
                                    )}
                                    trigger={["hover", "focus"]}
                                    placement={"bottom"}
                                  >
                                    <span class="color-xanh-bold">
                                      {formatNumber2(
                                        TongCanThanhToan +
                                          TongPhiKhac +
                                          TongPhiKho +
                                          TongPhiPhatDongLai -
                                          (TongThanhToan +
                                            TongPhiKho +
                                            TongPhiPhatDongLai),
                                      )}
                                    </span>
                                  </PopoversBootrap>
                                </p>
                              </div>
                            )}
                            {objThietLapHienThiDanhSach.IsAnCacLanDong !=
                              true && (
                              <div
                                class="custom-table-header flex-basis-14 flex-basis-16-sm"
                                style={{ minHeight: "82px" }}
                              >
                                <p class="tab-header text-center">
                                  Các lần đóng <br />
                                  &nbsp;
                                </p>
                              </div>
                            )}
                            {objThietLapHienThiDanhSach.IsAnThaoTac != true &&
                              this.state.HasTatToanChoDuyet !== 1 && (
                                <div
                                  class="custom-table-header flex-basis-5 flex-basis-2-sm sticky-col-new first-col-new"
                                  style={{ minHeight: "82px" }}
                                >
                                  <p class="tab-header text-center">Thao tác</p>
                                </div>
                              )}
                          </div>

                          <div class="custom-table-body">
                            <div class="custom-table-row">
                              <div class="custom-table-cell username-cell-mobile flex-basis-5 disk-desktop show-mobile">
                                <span class="mobile-column-name color7">
                                  Ngày trả lãi
                                </span>
                                <div class="center-wrapper">
                                  <p class="text-center">Cần thanh toán</p>
                                </div>
                              </div>
                            </div>
                            {this.renderRow(List)}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="table-from-new">
                    <div class="footer-page-new footer-dong-lai">
                      <div class="row">
                        <div class="col-xl-4 col-lg-12">
                          {data.Type == 2 || data.Type == 3 ? (
                            <button
                              type="button"
                              className="btn btn-new-main btn-checknew disk-mobile"
                              onClick={this.props.onShowInDanhSachDongLai(data)}
                              style={{ height: "35px" }}
                            >
                              <img src="/app-assets/images/icon-in-danh-sach.png" />
                              &nbsp;
                              <span>In danh sách</span>
                            </button>
                          ) : (
                            <InLanDongLai data={data}></InLanDongLai>
                          )}

                          {data.Type == 2 && (
                            <button
                              type="button"
                              style={{ height: "35px", marginLeft: "10px" }}
                              className="button-new1 btn btn-new-main btn-checknew disk-mobile "
                              onClick={this.props.onShowSuaKyLai(
                                data,
                                quanlychovay.objListDonglai,
                              )}
                            >
                              <img src="/app-assets/images/icon-sua-v2.png" />
                              &nbsp;
                              <span>Sửa kỳ lãi</span>
                            </button>
                          )}
                        </div>
                        <div class="col-xl-6 col-lg-12">
                          <div class="paniation-new d-flex just-end">
                            <nav aria-label="Page navigation">
                              <Pagination
                                activePage={dataSearch.pageIndex}
                                itemsCountPerPage={10}
                                totalItemsCount={totalRow}
                                pageRangeDisplayed={5}
                                onChange={this.handlePageChange}
                                itemClass="page-item border-none"
                                linkClass="page-link border-none"
                                activeClass="active"
                              />
                            </nav>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="width-left-from order-lg-2 order-1 pt-1">
                  <div class="title-donglai-mobile disk-desktop show-mobile">
                    <ul class="nav nav-tabs bg-tab">
                      <li
                        class={
                          "nav-item active" +
                          (isShowFormDongLai ? " collapsed-mobile" : "")
                        }
                        id="showdonglai"
                      >
                        <a
                          class="nav-link active"
                          id="base-tab1"
                          data-toggle="tab"
                          aria-controls="tab1"
                          href="#tab-thongtintt"
                          onClick={this.showFormInMobile}
                          aria-expanded="true"
                        >
                          <h4>
                            <span class="btn-icon-mobile">
                              Đóng lãi tuỳ biến theo ngày
                            </span>
                          </h4>
                        </a>
                      </li>
                    </ul>
                  </div>

                  <div
                    class="donglai-form form-donglai-mobileshow"
                    style={{ display: isShowFormDongLai ? "block" : "none" }}
                  >
                    <h4>
                      <span style={{ fontWeight: "bold !important;" }}>
                        {" "}
                        <img
                          src="/app-assets/images/icon-dong-lai.png"
                          style={{ marginBottom: "5px" }}
                        />
                        &nbsp;&nbsp;
                        {data.Type === 5 ? "Đóng tiền" : "Đóng lãi"}{" "}
                        {soNgayQuanHan && "quá hạn"}
                      </span>
                    </h4>
                    <div class="body-donglai">
                      <div class="basic-form">
                        {soNgayQuanHan && (
                          <div class="form-group">
                            <label class="text-label color-tim-bold">
                              Lãi từ ngày:{" "}
                            </label>
                            <span class="color7">{getDate(ngayBatDau)}</span>
                          </div>
                        )}

                        <div class="form-group">
                          <label class="text-label  color-tim-bold">
                            Ngày thanh toán
                          </label>
                          <div class="date-control color7">
                            <DateTimePicker
                              value={NgayThanhToan}
                              onChange={this.onChangeDate()}
                              name="NgayVay"
                              readOnly={!chonngaygiaodich}
                            ></DateTimePicker>
                          </div>
                        </div>
                        {soNgayQuanHan && (
                          <div class="form-group">
                            <label class="text-label">Số ngày: </label>
                            <span class="red">{soNgayQuanHan}</span>
                          </div>
                        )}

                        <div class="form-group">
                          <label class="text-label color-tim-bold">
                            Người thanh toán
                          </label>
                          <input
                            type="text"
                            class="form-control input-sm color7 "
                            placeholder=""
                            value={objThanhToan.CustomerName}
                            onChange={this.onChangeText("CustomerName")}
                          />
                        </div>
                        <div class="form-group">
                          <label class="text-label color-tim-bold">
                            {!soNgayQuanHan && "Tiền thanh toán"}
                            {soNgayQuanHan && "Tiền lãi quá hạn"}
                          </label>
                          <input
                            type="text"
                            name=""
                            class="form-control input-sm color7"
                            placeholder=""
                            value={formatNumber2(objThanhToan.SoTien)}
                            onChange={this.onChangeNumber("SoTien")}
                          />
                        </div>
                        <div class="form-group">
                          <label class="text-label color-tim-bold">
                            Phí khác
                          </label>
                          <input
                            type="text"
                            name=""
                            class="form-control input-sm color7"
                            placeholder=""
                            value={formatNumber2(objThanhToan.PhiKhac)}
                            onChange={this.onChangeNumber("PhiKhac")}
                          />
                        </div>
                        {isWinmoney && (
                          <div class="form-group">
                            <label class="text-label color-tim-bold">
                              Tiền phạt trả chậm
                              {soNgayTraCham > 0 && (
                                <span class="red">
                                  {" "}
                                  {soNgayTraCham > soNgayTinhPhat
                                    ? "(trễ " +
                                      soNgayTraCham +
                                      " ngày, tính " +
                                      soNgayTinhPhat +
                                      " ngày)"
                                    : "(" + soNgayTraCham + " ngày)"}
                                </span>
                              )}
                            </label>
                            <input
                              type="text"
                              name=""
                              class="form-control input-sm color7"
                              placeholder=""
                              value={formatNumber2(objThanhToan.PhiPhatTraCham)}
                              onChange={this.onChangeNumber("PhiPhatTraCham")}
                            />
                          </div>
                        )}
                        {isShowPhiKho === 1 &&
                          data.Type == 3 &&
                          objThietLapHienThiDanhSach.IsAnPhiKho != true && (
                            <div class="form-group">
                              <label class="text-label color-tim-bold">
                                Phí kho
                              </label>
                              <input
                                type="text"
                                name=""
                                class="form-control input-sm color7"
                                placeholder=""
                                value={formatNumber2(objThanhToan.PhiKho)}
                                onChange={this.onChangeNumber("PhiKho")}
                              />
                            </div>
                          )}
                        {SuDungPhiPhat_DongLai_TatToan && (
                          <div class="form-group">
                            <label class="text-label color-tim-bold">
                              Phạt chậm đóng lãi
                            </label>
                            <input
                              type="text"
                              name=""
                              class="form-control input-sm color7"
                              placeholder=""
                              value={formatNumber2(objThanhToan.PhiPhatTraLai)}
                              onChange={this.onChangeNumber("PhiPhatTraLai")}
                            />
                          </div>
                        )}
                        {SuDungPhiPhat_DongLai_Cham && !isWinmoney && (
                          <div class="form-group">
                            <label class="text-label color-tim-bold">
                              Phạt chậm đóng lãi
                            </label>
                            <input
                              type="text"
                              name=""
                              class="form-control input-sm"
                              placeholder=""
                              value={formatNumber2(objThanhToan.PhiDongLaiCham)}
                              onChange={this.onChangeNumber("PhiDongLaiCham")}
                            />
                          </div>
                        )}
                        {!soNgayQuanHan && (
                          <div class="form-group">
                            <label class="text-label color-tim-bold">
                              Ghi chú
                            </label>
                            <textarea
                              rows="2"
                              class="form-control input-sm color7"
                              name="comment"
                              placeholder="Nhập nội dung ghi chú"
                              value={objThanhToan.GhiChu}
                              onChange={this.onChangeText("GhiChu")}
                            ></textarea>
                          </div>
                        )}
                        {showPhiPhat && (
                          <div class="form-group">
                            <label class="text-label color-tim-bold">
                              Kênh thanh toán
                            </label>
                            <select
                              onChange={this._onSelectKenhThanhToan(
                                "KenhThanhToan",
                              )}
                              value={objThanhToan.KenhThanhToan}
                              className="form-control input-sm color7"
                            >
                              {combo.map((item) => {
                                return (
                                  <option
                                    value={item.value}
                                    label={item.label}
                                  ></option>
                                );
                              })}
                            </select>
                          </div>
                        )}

                        {!soNgayQuanHan && data.TypePaid != 3 ? (
                          <div class="form-group">
                            <label>
                              <input
                                type="checkbox"
                                value={objThanhToan.DoiKy}
                                onChange={this.onChangeCheckbox()}
                              />
                              <span class="check-box color7">
                                {" "}
                                &nbsp;Đổi kỳ thanh toán
                              </span>
                            </label>
                          </div>
                        ) : (
                          <div></div>
                        )}
                        {/* {isQRThanhToan && (
                          <>
                            <div class="form-group">
                              <label class="text-label">Ngân hàng: </label>
                              <select
                                class="form-control input-sm"
                                value={bankId}
                                onChange={this.updateSelectBank()}
                              >
                                <option value="">Tiền mặt</option>
                                {lstBank && lstBank.map((item, idx) => (
                                  <option
                                    key={"comboBank" + idx}
                                    value={item.Id}>
                                    {item.MaNganHang + " - " + item.SoTaiKhoan}
                                  </option>
                                ))}
                              </select>
                            </div>
                            <div>
                              <div class="form-group">
                                <button
                                  type="button"
                                  class="btn btn-new-main btn-checknew"
                                  onClick={this.ShowQR()}
                                >
                                  <span class="btn-icon-left">
                                    <i class="mdi mdi-qrcode"></i>
                                  </span>

                                </button>
                                <img src={imgUrlQR} style={{ width: "150px" }} />
                              </div>

                            </div>
                          </>
                        )} */}

                        <div class="dropdown-divider"></div>
                        {this.state.HasTatToanChoDuyet !== 1 && (
                          <div class="text-right">
                            {isQRThanhToan && (
                              <button
                                type="button"
                                class="btn btn-new-main btn-checknew"
                                onClick={this.thanToanCho()}
                                style={{ marginRight: "5px" }}
                              >
                                <span class="btn-icon-left">
                                  <i class="mdi mdi-check-underline-circle"></i>
                                </span>
                                Thanh toán chờ
                              </button>
                            )}
                            <button
                              type="button"
                              class="btn btn-new-main btn-checknew"
                              onClick={this.thanToanAll()}
                            >
                              <span class="btn-icon-left">
                                <i class="mdi mdi-check-underline-circle"></i>
                              </span>
                              Xác nhận
                            </button>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </Tab>
            <Tab
              eventKey="ThongTinHopDong"
              title={<h4 className="tab-v2">Thông tin hợp đồng</h4>}
            >
              <ChiTietChoVaySub
                data={data}
                isCauHinhKhachHangVSNY={isCauHinhKhachHangVSNY}
              ></ChiTietChoVaySub>
            </Tab>
            <Tab
              eventKey="LichSuDongLai"
              title={<h4 className="tab-v2">Lịch sử đóng lãi</h4>}
            >
              <LanDongLaiSub
                data={data}
                showPhiPhat={showPhiPhat}
                soNgayQuanHan={soNgayQuanHan}
              ></LanDongLaiSub>
            </Tab>
            <Tab
              eventKey="LichSuThuPhi1Lan"
              title={<h4 className="tab-v2">Lịch sử thu phí 1 lần</h4>}
            >
              <div
                class="table-responsive table-responsive-new table-new1  table-rounded"
                style={{ color: "#363636", marginTop: "10px" }}
              >
                <div class="custom-table-wrapper custom-border-mm">
                  <div class="table-headers">
                    <div class="custom-table-header flex-basis-5">
                      <p class="text-center">
                        STT <br />
                        &nbsp;
                      </p>
                    </div>
                    <div class="custom-table-header flex-basis-5">
                      <p class="text-center">
                        Thời gian <br />
                        &nbsp;
                      </p>
                    </div>
                    <div class="custom-table-header flex-basis-15">
                      <p class="text-center">
                        Tên <br />
                        &nbsp;
                      </p>
                    </div>
                    <div class="custom-table-header flex-basis-5">
                      <p class="text-right">
                        LS Phí <br />
                        &nbsp;
                      </p>
                    </div>

                    <div class="custom-table-header flex-basis-10">
                      <p class="text-right">
                        Tính theo
                        <br />
                        &nbsp;
                      </p>
                    </div>

                    <div class="custom-table-header flex-basis-10">
                      <p class="text-right">
                        Tổng tiền
                        <br />
                        <span class="color-do-bold">
                          {formatNumber(totalPhiKhac)}
                        </span>
                      </p>
                    </div>
                  </div>
                  <div class="custom-table-body">{this.renderRowPhiKhac()}</div>
                  <div class="footer-page-new">
                    <div class="row" style={{ padding: "10px" }}>
                      <div class="col-xl-6 col-lg-12">
                        <InDanhSachPhiKhac data={data}></InDanhSachPhiKhac>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </Tab>
          </Tabs>
        </Modal.Body>
        <Modal.Footer>
          <div class="from-button-modal">
            <div class="row">
              <div class="col-md-9">{buttonLeft}</div>
              <div class="col-md-3 text-right">
                <button
                  type="button"
                  class="btn btn-new-main btn-closenew"
                  onClick={props.onHide}
                >
                  <span>
                    <i class="mdi mdi-close"></i>
                  </span>
                  &nbsp; Đóng
                </button>
              </div>
            </div>
          </div>
        </Modal.Footer>
        {this.state.isShowModalThietLapHienThi && (
          <ModelThietLapHienThi
            show={this.state.isShowModalThietLapHienThi}
            onHide={this.toggleModalThietLapHienThi.bind(this)}
            data={this.state.objThietLapHienThiDanhSach}
            dataChoVay={this.props.data}
            isShowPhiKho={this.props.isShowPhiKho}
            SuDungPhiPhat_DongLai_TatToan={
              this.props.SuDungPhiPhat_DongLai_TatToan
            }
            isCauHinhT86={this.props.isCauHinhT86}
            SuDungPhiPhat_DongLai_Cham={this.props.SuDungPhiPhat_DongLai_Cham}
            showPhiPhat={this.props.showPhiPhat}
            getThietLapHienThi={this.getThietLapHienThi.bind(this)}
          />
        )}
      </Modal>
    );
  }
}
export default DongLai;
